import  React, { Component, useEffect } from 'react';
import { List,ListItem,ListSubheader,ListItemIcon,ListItemText,Collapse } from '@mui/material';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import DraftsIcon from '@mui/icons-material/Drafts';
import SendIcon from '@mui/icons-material/Send';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import StarBorderIcon from "@mui/icons-material/StarBorder";

export default function FullDetails({bio_markers, profiles, }) {
    console.log("bio_markers, profiles",bio_markers, profiles);
    const [open, setOpen] = React.useState(true);
    const [totalPackages, setTotalPackages ] = React.useState();
    console.log("bio_markers", bio_markers, "profiles", profiles);
    const handleClick = () => {
      setOpen(!open);
    };
    const totalPacakges = () => {
         let len = bio_markers && bio_markers.length;
         console.log(len);
         let totalLen = profiles &&  profiles.reduce((total, test) => {
              return total + (test && test.totalBioMarkers);
         } ,len);
         console.log("finalLength:", totalLen);
         setTotalPackages(totalLen);
    }
    const BioMarker = (biomarker,index) => (
      <ListItem key = {index}>
        <ListItemText  sx = {{minWidth : '100px'}} primary = {biomarker.packageName} />
      </ListItem>
    );

    const ProfileView = (profile) => {
        return profile.bio_markers.map((biomarker, index) => BioMarker(biomarker, index))
    }
  
    useEffect(() => {
      totalPacakges();
    }, [bio_markers])
    

    return (
      <List
        component="nav"
        aria-labelledby="nested-list-subheader"
        subheader={
          <ListSubheader component="div" id="nested-list-subheader" color = "primary" disableGutters = {true} sx = {{ width: '100%', height: 50, bgcolor: 'background.paper' }}>
                LabTests - {totalPackages}
          </ListSubheader>
        }
      >
          {bio_markers ? bio_markers.map((val,index) => BioMarker(val,index)) : <></>}
          {profiles ? profiles.map((val,index) => ProfileView(val)) : <></>}
          {/* {open ? <ExpandLess /> : <ExpandMore />} */}
         {/* <Collapse in={open} timeout="auto" unmountOnExit>
           <List component="div" disablePadding>
              <ListItemIcon>
                <StarBorderIcon />
              </ListItemIcon>
              <ListItemText primary="Starred" />
          </List> 
        </Collapse>  */}
      </List>
    );
  }
